<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <div id="formTable">
      <div class="formTableItem">
        <Button @click="openAdd" type="primary" class="chaxun">新增</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="imgPath2">
        <viewer v-if="row.imgPath != null && row.imgPath.length > 0">
          <img
            v-for="(x, index) in row.imgPath2"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增订单清单核查' : '编辑订单清单核查'"
      width="700"
      ref="formModel"
    >
      <FormItem slot="form" slot-scope="{ row }" label="名称" prop="name">
      </FormItem>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },

        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        oid: 0,
        oNo: "",
        groupId: "",
        groupName: "",
        lable: "",
        role: "",
        comment: "",
        remark: "",
        imgPath: "",
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      categorys: [],
      forms: [
        {
          title: "订单号",
          key: "ono",
          type: "Select",
          selectItems: [],
        },
        {
          title: "单位名称",
          key: "groupId",
          key1: "groupName",
          type: "selectGroup",
          required: true,
        },

        {
          title: "标签",
          key: "lable",
          type: "Select",
          selectItems: ["装货核查", "卸货核查", "出入仓核查", "运输核查"],
        },
        {
          title: "角色",
          key: "role",
          type: "Input",
        },
        {
          title: "意见",
          key: "comment",
          type: "Input",
        },
        {
          title: "附件",
          key: "imgPath2",
          slot: "imgPath2",
          type: "lyPhoto",
        },
        {
          title: "备注",
          key: "remark",
          type: "Input",
          type1: "textarea",
          span: 24,
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/ordersGoodsCheck/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);
        for (let i = 0; i < data.length; i++) {
          data[i].imgPath2 = JSON.parse(data[i].imgPath);
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item.imgPath = JSON.stringify(a.imgPath2);
      this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-omc/ordersGoodsCheck/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url:
            this.axios.ipPort + "/cloud-tms-server-omc/ordersGoodsCheck/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url:
              this.axios.ipPort + "/cloud-tms-server-omc/ordersGoodsCheck/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getOrdersList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/orders/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < this.forms.length; i++) {
          if (this.forms[i].key == "ono") {
            this.forms[i].selectItems = [];
            for (let j = 0; j < data.length; j++) {
              this.forms[i].selectItems.push(data[j].no);
            }
          }
        }
      });
    },
    cols() {
      var b = JSON.parse(JSON.stringify(this.forms));
      //b.splice(2, 4);
      for (let i = 0; i < b.length; i++) {
        if (!b[i].minWidth && !b[i].maxWidth) {
          b[i].minWidth = 200;
          b[i].maxWidth = 300;
        }
        if (b[i].key1) {
          b[i].key = b[i].key1;
        }
        if (b[i].key2) {
          b[i].key = b[i].key2;
        }
      }
      this.columns.splice(1, 0, ...b);
      //a.splice.apply(a,[i,0].concat(b));//es5写法
    },
  },
  mounted() {
    this.cols();
    this.getList();
    this.getOrdersList();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/dingdan/dingdanhecha.vue